import React from "react";
import styles from "./toggle.module.css";
const Toggle = ({ value, onChange }) => {
  return (
    <label className={styles.switch}>
      <input 
      type="checkbox" 
      className={styles.input} 
      checked={value} 
      onChange={onChange}
      />
      <span className={`${styles.slider} ${styles.round}`}></span>
    </label>
  );
};

export default Toggle;
